import first from 'lodash/first'

import React from 'react'
import { usePaymentMethodPanelContext as paymentMethodContext } from './Context'
import { Box, ShowIf } from '@ztechapps/webui.util'
import { CardPanel } from './CardPanel'
import { BankPanel } from './BankPanel'
import { useToggle } from 'react-use'
import { OrderItemsPreview } from './OrderItemsPreview'
import { PaymentMethodEnum } from '@ztechapps/common.contract'
import { CheckboxInput } from '@ztechapps/webui.input'
import { useCheckoutContext } from '../../../index'

export const Payments = () => {
  const context = useCheckoutContext()

  const { components } = paymentMethodContext()

  const [activePanel, setActivePanel] = React.useState(PaymentMethodEnum.card)
  const [showOrderItems, setShowOrderItems] = useToggle(false)

  const [paymentMethods] = context.paymentMethods

  React.useEffect(() => {
    setActivePanel(first(paymentMethods))
  }, [paymentMethods])

  return (
    <Box>
      <Box.Body>
        <div className={'d-flex justify-content-end'}>
          <div>
            <CheckboxInput checked={showOrderItems} onClick={setShowOrderItems} label={`Show ordered items`} />
          </div>
        </div>

        <div className="my-2">
          <ShowIf condition={activePanel === PaymentMethodEnum.card}>
            <CardPanel />
          </ShowIf>
          <ShowIf condition={activePanel === PaymentMethodEnum.achDirectDebit}>
            <BankPanel />
          </ShowIf>
          <ShowIf condition={activePanel === PaymentMethodEnum.cash}>
            <components.cashPanel />
          </ShowIf>
        </div>
        <ShowIf condition={showOrderItems}>
          <OrderItemsPreview />
        </ShowIf>
      </Box.Body>
    </Box>
  )
}
